import { useApiQuery, VenuesApi } from "@xs2event/js-lib/api";
import type { MaybeRef } from "vue";
import { unref } from "vue";

const api = new VenuesApi();

export const useVenues = () => {
  const useVenue = (id: MaybeRef<string>) => {
    return useApiQuery(api, "venueGet", { venueId: unref(id) }, { enabled: !!unref(id) });
  };
  return { useVenue };
};
